import React, { useState,useContext,useRef,useEffect,useCallback } from "react";
import { useLocalStorage } from '_context/commonHooks';
import { LayoutContext,SideBarContext } from '_context/LayoutContext';
import { MapContext } from '_context/MapContext';
import RPSearch from 'component/RPSearch';
import { RPResult,WayPointSelect } from './RPResult';
import { useWindowSize  } from '_context/commonHooks';
import { RPHistoryCom, RPSearchResult } from 'component/RPSearchResult';
import RPNearSearch from 'component/RPNearSearch';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { Footer } from 'component/Footer';
import { Loading } from 'component/Loading';
import Card from './Card';
import { getItem, getRouteItem } from '_services/agent';
import util from 'common/util';
import { DndProvider } from 'react-dnd'
import Backend from 'react-dnd-html5-backend'
import update from 'immutability-helper'
//import loading from 'resources/imgs/loading.png';

const RP = () => {
	//const [history,setHistory] = useLocalStorage('GIS_RPList',window.localStorage.getItem('GIS_RPList') || []);
	const {RPhistory, setRPhistory} = useContext(MapContext);
	const { setPoi, selectedPoi, rp, setRP, resetRP, setRoutes,setRPOpts,rpOpts,selectedTbt,ktMapIns, rpDrag, setRpDrag } = useContext(MapContext);
	const [ target, setTarget] = useState("start");
	const [ ready, setReady] = useState(false);
	const [ startValue, setStartValue ] = useState(rp.start || null);
	const [ endValue, setEndValue ] = useState(rp.end || null);
	const [ wayPointsValue, setWayPointsValue ] = useState(rp.wayPoints || []);
	const [ loading, setLoading ] = useState(false);
	const { sidebar,toggle } = useContext(SideBarContext);
	const [ rpMode, setRPMode ] = useState(0); /* mode 0:default / 1:search / 2:route */

	const { chgStatus, status } = useContext(LayoutContext);
	const [ searchKeyword, setSearchKeyword] = useState("");
	const [wayPointsMode, setWayPointsMode] = useState(false)
	const [isDisabledWay, setIsDisabledWay] = useState(false)
	

	const [rpData, setRPData] = useState([]);
	const [addrData, setAddrData] = useState([]);
	const [poiData, setPoiData] = useState([]);
	const [pages, setPages] = useState({
		pageCount : null,
		pageIndex : 0,
		pageTotal : 0,
		addrTotal : 0,
		sort : "relevance",
		rememberPoint:null
	})
	const rpRef = useRef();
	const remeberRoutes = useRef()
	const startSelectRef = useRef()
	const waySelectRef = useRef()
	const endSelectRef = useRef()
	const [signal, setSignal] = useState(null);
	const [startSignal, setStartSignal] = useState(null);
	const [endSignal, setEndSignal] = useState(null);

	useEffect(() => {
		if(status==='rp' && !sidebar){
			toggle("sidebar")
		}
		if((status==='rp' || status==='simul') && remeberRoutes.current){
			rpDispose(remeberRoutes.current);
		}else if(status==='search'){
			setRPData([]);
			setRoutes([]);
			setLoading(false);
		}
	}, [status]);

	useEffect(() => {
		if(rp.start && rp.end && rp.start.point && rp.end.point){
			setReady(true);
		}
		if(rp.wayPoints !== undefined){
			setWayPointsValue(rp.wayPoints)
			if(rp.wayPoints.length>0){
				setWayPointsMode(true)
			}
			if(rp.wayPoints.length===12){
				setIsDisabledWay(true)
			}else{
				setIsDisabledWay(false)
			}
		}
		return ()=>{
			setReady(false);
		}
	}, [rp]);

	useEffect(() => {
		if(rp.start !== undefined){
			setStartValue(rp.start)
		}
	}, [rp.start]);

	useEffect(() => {
		if(rp.end !== undefined){
			setEndValue(rp.end)
		}
	}, [rp.end]);

	useEffect(() => {
		if(rpRef.current===undefined){return }
		if(sidebar && selectedTbt){
			var elem = document.getElementById("tbtlist-"+selectedTbt);
			let tbtInstance =  rpRef.current.osInstance();
			if(tbtInstance && elem){
				tbtInstance.scroll(elem,500);
			}
		}
	},[selectedTbt]);
	
 	useEffect(() => {
		if(rpMode===1){
			searchData(pages.pageIndex, null, target);
		}
	}, [pages.sort]);

	useEffect(() => {
		if(rpDrag){
			onSubmit()
		}
	}, [rpDrag])

	// const routeChck = (key, point, keyword)=>{
	// 	let overLapCheck = false
	// 	if(key!=='start' && point && rp && rp.start && rp.start.point && rp.start.point.lat===point.lat && rp.start.point.lng===point.lng){
	// 		alert('출발지와 같은장소입니다.')
	// 		overLapCheck = true
	// 	}
	// 	if(key!=='end' && point && rp && rp.end && rp.end.point && rp.end.point.lat===point.lat && rp.end.point.lng===point.lng){
	// 		alert('도착지와 같은장소입니다.')
	// 		overLapCheck = true
	// 	}
	// 	if(key!=='wayPoints' && point && rp && rp.wayPoints){
	// 		rp.wayPoints.some((wayPoint)=>{
	// 			if(wayPoint.point && wayPoint.point.lat===point.lat && wayPoint.point.lng===point.lng){
	// 				alert('경유지에 같은장소 이미 입력되었습니다.')
	// 				overLapCheck = true
	// 				return false
	// 			}
	// 		})
	// 	}
	// 	if(overLapCheck){
	// 		if(key==="start"){
	// 			setRP(key,'');
	// 			setStartSignal(util.guid())
	// 		}
	// 		if( key==="end"){
	// 			setRP(key,'');
	// 			setEndSignal(util.guid())
	// 		}
	// 	}
	// 	return overLapCheck
	// }

	const setRoutePoi = (key, keyword, point) =>{ 
		// if(routeChck(key, point, keyword)){
		// 	return
		// }
		let chk = false
		let newRP = {keyword:keyword,point}
		if(point){
			if(key==="start"){
				chk = setRP(key,newRP);
				if(chk){
					setStartValue(newRP.keyword)
				}
			}else if(key==="end"){
				chk = setRP(key,newRP);
				if(chk){
					setEndValue(newRP.keyword)
				}
			}else if(key==="wayPoints"){
				chk = setRP(key,newRP,'add');
				if(chk){
					let newWayPoints = rp["wayPoints"]?[...rp["wayPoints"], newRP]:[newRP]
					setWayPointsValue(newWayPoints)
				}
			}
		}
		if(!point){
			searchData(0,keyword, key);
			setSearchKeyword(keyword)
		}
		setTarget(key)

		if(!chk){
			if(key==="start"){
				setRP(key,null);
				setStartSignal(util.guid())
			}
			if( key==="end"){
				setRP(key,null);
				setEndSignal(util.guid())
			}
		}
	}

	const setDirectRoutePoi = (ref, key)=>{
		if(ref.current.props.value){
			setRoutePoi(key, ref.current.props.value.value, null)
		}
		if(key==='wayPoints'){
			setSignal(util.guid())
		}
	}

	const onSubmit = () => {
		let now = new Date().getTime();
		setRpDrag(false)
		fetchData();
		setRPhistory({"timestamp":now,"rp":rp})
	}

	const onReset = () => {
		resetRP();
		setRPMode(0);
		setStartValue(null);
		setEndValue(null);
		setWayPointsValue([]);
		setRPData([]);
		setRoutes([]);
		remeberRoutes.current = null;
	}

	const onChange = (name,value) => {
		setPages({
			...pages, 
			[name]: value 
		});
	};

	const setRPFromHistory = (obj,type) => {
		let chk = true
		if(type==="rp"){
			setStartValue(obj.start);
			setEndValue(obj.end);
			setRP("all",obj);
		}else{
			if(target==='start'){
				setStartValue({keyword:obj.name, point:obj.point});
				chk = setRP(target,{keyword:obj.name, point:obj.point});
			}else if(target==='end'){
				chk = setRP(target,{keyword:obj.name, point:obj.point});
				if(chk){
					setEndValue({keyword:obj.name, point:obj.point});
				}
			}else if(target==='wayPoints'){
				chk = setRP(target,{keyword:obj.name, point:obj.point}, 'add');
			}
		}
		if(!chk){
			if(target==="start"){
				setRP(target,null);
				setStartSignal(util.guid())
			}
			if( target==="end"){
				setRP(target,null);
				setEndSignal(util.guid())
			}
		}
	}

	const setPageIndex = (idx,mode) => {
		onChange("pageIndex",idx)
		if(mode){searchData(idx, null, target);}
	}

	const onChangePages = (name,value)=>{
		onChange(name,value)
	}

	async function searchData(pageIndex,keyword,key){
		if(pageIndex===0){
			let centerPoint = ktMapIns.getCenter()
			let latlng = util.utmkToLatlng(centerPoint.x, centerPoint.y)
			let point = {lat: latlng.x, lng: latlng.y}
			pages.rememberPoint = point
		}
		
		await getItem('poi','?sortBy='+pages.sort+'&mode=NAVIGATION&numberOfResults=10&start='+(pageIndex*10),{
			point: pages.rememberPoint,
			terms: keyword?keyword:searchKeyword
			}).then(res => {
				if(res.data.numberOfPois && res.data.numberOfPois>20000){
					res.data.numberOfPois = 20000
				 }
				let serverData = res.data;
				setPoiData(serverData.pois);
				setAddrData(serverData.residentialAddress);
		
				setPages({
				...pages,
				pageCount: Math.ceil(serverData.numberOfPois / 10),
				pageTotal: serverData.numberOfPois,
				addrTotal : serverData.numberOfAddress
				})

				setPoi(serverData);
				setRPMode(1);

				//주소가 기본이 아닌 POI가 기본적으로 선택되도록 주석처리함.
				if(serverData.numberOfAddress > 0){ 
					let addrFlag = serverData.residentialAddress[0].parcelAddress.length?"parcelAddress":"roadAddress";
					let addrObj = serverData.residentialAddress[0][addrFlag][0];
					selectedPoi(addrFlag==="parcelAddress"?addrObj.pnucode:addrObj.rbucode);
					setRoutePoi(key, addrObj.fullAddress, addrObj.geographicInformation.point)
				}else{
					selectedPoi(serverData.pois[0].id);
					setRoutePoi(key, serverData.pois[0].name+' '+serverData.pois[0].branch, serverData.pois[0].point)
				}
				selectedPoi(serverData.pois[0].id);
				if(key==='start' || key==='end'){
					setRoutePoi(key, serverData.pois[0].name+(serverData.pois[0].branch ? ' '+serverData.pois[0].branch : '')+(serverData.pois[0].subName ? ' '+serverData.pois[0].subName : ''), serverData.pois[0].point)
				}else if(key==='wayPoints'){
					if(rp.start && rp.end && rp.start.point && rp.end.point){
						setReady(true);
					}
				}
			}).catch(err => {

				}
			);
		};
		
		
	async function fetchData(){
		setLoading(true);
		setRPOpts("rpType",0);
		let pois = [rp.start, rp.end]
		if(rp.wayPoints && rp.wayPoints.some){
			rp.wayPoints.some((element) => {
				pois.push(element)
			})
		}

		let changeCnt = 0
		for(const element of pois){
			if(element.point.poiId && element.point.multipleEntrance && util.dateDiff(element.point.time, new Date().getTime())>6){
				let param = '/' + element.point.poiId +'?mode=NAVIGATION'
				await getItem('poi',param, null, 'GET').then(res => {
					if(res.data.pois && res.data.pois.length>0){
						element.keyword = res.data.pois[0].name + (res.data.pois[0].branch ? ' '+res.data.pois[0].branch : '') + (res.data.pois[0].subName ? ' '+res.data.pois[0].subName : '')
						element.point.multipleEntrance = res.data.pois[0].routeOptimization.multipleEntrance
						element.point.time = util.getFormatDate(new Date())
						changeCnt++
					}
				}).catch(err => {console.log(err)})
			}
		}
		if(changeCnt>0){
			setRPhistory({"timestamp":new Date().getTime(),"rp":rp})
		}
		let start = navigationPointCovert(rp.start.point, true);
		let end = navigationPointCovert(rp.end.point)
		let wayPoints = sdkWayPoints()
		await getRouteItem({start:start, end:end, waypoints:wayPoints, rp_type:'0;7;3;2', startName:rp.start.keyword, endName:rp.end.keyword})
		.then(res => {
			if(rpVal(res)){
				remeberRoutes.current = res.routes;
				rpDispose(res.routes)
			}else{
				alert("지원하지 않는 길찾기 경로입니다.")
				setRPData([]);
				setRoutes([]);
				setLoading(false);
			}
		}).catch(err => {
			alert("지원하지 않는 길찾기 경로입니다.")
			setRPData([]);
			setRoutes([]);
			setLoading(false);
		});
	};

	const rpVal = (res)=>{
        if(!res.routes || res.routes[0].links.length===0){
            return false
        }
        return true
    }

	const navigationPointCovert = (point, poiPointYN=false) => {
		if(poiPointYN){
			let po = util.latlngToUtmk(point.lat, point.lng);
			return `${po.x},${po.y}`
		}
		if(point.multipleEntrance){
			let result = ''
			point.multipleEntrance.some((naviPoint, idx) => {
				let utmkPoint = util.latlngToUtmk(naviPoint.lat, naviPoint.lng);
				if(idx===0){
					result = `${utmkPoint.x},${utmkPoint.y}`
				}else{
					result += `+${utmkPoint.x},${utmkPoint.y}`
				}
			})
			return result
		}else{
			let utmkPoint = util.latlngToUtmk(point.lat, point.lng);
			return `${utmkPoint.x},${utmkPoint.y}`
		}
	}

	const sdkWayPoints = ()=>{
		let result = ''
		if(rp && rp.wayPoints){
			rp.wayPoints.some((element) => {
				let wayPoint = navigationPointCovert(element.point)
				result += result==='' ? wayPoint : `;${wayPoint}`
			})
		}
		return result
	}

	const rpDispose = (routes)=>{
		setRPData(routes);
		setRoutes(routes);
		setRPMode(2);
		//setRPOpts("rpType",0);
		setLoading(false);
	}

	const size = useWindowSize(rpRef); 
	let tmpH = window.document.body.offsetHeight-120;

	const wayPointsRender = (wayPoint, index) => {
		return (
			<Card text={wayPoint.keyword} wayPoint={wayPoint} index={index} key={wayPoint.keyword} moveCard={moveCard} deleteCard={deleteCard}/>
		)
	}

	const moveCard = useCallback((dragIndex, hoverIndex) => {
		const dragWayPoint = wayPointsValue[dragIndex];
		let changeArr = update(wayPointsValue, {
			$splice: [[dragIndex, 1], [hoverIndex, 0, dragWayPoint]]
		})
		setWayPointsValue(changeArr);
		setRP('wayPoints', changeArr, 'change');
	},[wayPointsValue]);

	const deleteCard = (wayPoint) => {
		setRP('wayPoints', wayPoint, 'delete');
	}

	const onStartEndChange = () => {
		if(rp['start'] && rp['end']){
			let startInfo = JSON.parse(JSON.stringify(rp['start']))
			let endInfo = JSON.parse(JSON.stringify(rp['end']))
			setRP('start', endInfo, '', true)
			setRP('end', startInfo, '', true)
			if(rpData && rpData.length>0){
				onSubmit()
			}
		}
	}

    return (
		<React.Fragment>
		<div className={sidebar?"wrapSchResult wrapNavi naviRoute":"wrapSchResult wrapNavi hide"} style={{zIndex:20, display:status==='rp'||status==='routeNear'?'block':'none'}}>
		<div className="wrapPoint">
			<div className="menuTop">
				<button className="btnsBg menuLnb" onClick={() => toggle("lnb")}>메뉴</button>
				<ul>
					<li><a href="#" className="current">자동차</a></li>
					{/* <li><span className="disabled">대중교통</span></li>
					<li><span className="disabled">도보</span></li>
					<li><span className="disabled">자전거</span></li> */}
				</ul>
				<button className="btnsBg btnClose" onClick={()=>chgStatus("search")}>닫기</button>
			</div>
		</div>
		<div className="plugin-scrollbar-bd">
			<div className="plugin-scrollbar">
			<OverlayScrollbarsComponent ref={rpRef}style={{ maxHeight: tmpH, height:'100%' }}>
				<div className="pointList">
					<ul>
						<li>
							<span className="iconsNavi icStart"></span>
							<RPSearch selectRef={startSelectRef} handleFocus={()=>setTarget('start')} setRoutePoi={setRoutePoi} signal={startSignal} rid="start" placeholder="출발지를 검색하거나 클릭하세요." defValue={startValue} through={false}/>
							<button className="btnsBg btnFind" title="검색" onClick={()=>setDirectRoutePoi(startSelectRef, 'start')}>검색</button>
							<button className="btnsNavi btnReInput" title="다시입력" onClick={onReset}>다시입력</button>
							<button className="btnsNavi btnMove" title="출발지/목적지바꾸기" onClick={onStartEndChange}>출발지/목적지바꾸기</button>
							{/* <button className="btnsNavi btnReInput" title="다시입력" onClick={onStartEndChange}>다시입력</button> */}
						</li>
						<li style={{display:wayPointsMode?'block':'none'}}>
							<span className="iconsNavi icWaypoint"></span>
							<RPSearch  selectRef={waySelectRef} handleFocus={()=>setTarget('wayPoints')} isDisabled={isDisabledWay} signal={signal} selAfterClear={true} setRoutePoi={setRoutePoi} rid="wayPoints" placeholder="추가할 경유지를 선택하세요."  defValue={null} through={true}/>
							<button className="btnsBg btnFind" title="검색" onClick={()=>setDirectRoutePoi(waySelectRef, 'wayPoints')}>검색</button>
						</li>
						<li style={{display:wayPointsValue.length>0?'block':'none'}}>
							<DndProvider backend={Backend}>
								<div className="WrapMuch">{wayPointsValue.map((wayPoint, index) => wayPointsRender(wayPoint, index))}</div>
							</DndProvider>
						</li>
						<li>
							<span className="iconsNavi icDest"></span>
							<RPSearch  selectRef={endSelectRef} handleFocus={()=>setTarget('end')} setRoutePoi={setRoutePoi} signal={endSignal} rid="end" placeholder="목적지를 선택하세요."  defValue={endValue} through={false}/>
							<button className="btnsBg btnFind" title="검색" onClick={()=>setDirectRoutePoi(endSelectRef, 'end')}>검색</button>
							{/* <button className="btnsNavi btnMove" title="출발지/목적지바꾸기" onClick={onStartEndChange}>출발지/목적지바꾸기</button> */}
							<button className={wayPointsMode?'btnsNavi btnDel':'btnsNavi btnAdd'}  
								onClick={(e) => {
									if(wayPointsMode){
										setRP('wayPoints', [], 'change');
									}; 
									setWayPointsMode(!wayPointsMode)
								}}  
								title={wayPointsMode?'경유지 삭제':'경유지 추가'}>경유지 추가</button>
						</li>
					</ul>
					<div className="wrapRoadFind">
					<button  disabled={ready?"":"disabled"}  onClick={onSubmit}><span className="iconsNavi"></span><span>길찾기</span></button>
					</div>
					{/* <div className="startNow">
						<button><span>지금출발</span><span className="iconsArrow"></span></button>
						<div className="innerBox">
							<a href="#">지금출발</a>
							<a href="#">출발시간</a>
						</div>
					</div> */}
				</div>
				{
					!loading &&  rpMode===0 && <RPHistoryCom setRPFromHistory={setRPFromHistory} /> 
				}
				{loading ? <Loading type="rp" /> :
					rpMode===1?
					<RPSearchResult data={poiData} addrData={addrData} pages={pages} mode="rp" target={target} setRoutePoi={setRoutePoi} onChangePages={onChangePages} />:
					rpMode===2?<RPResult data={rpData} start={startValue?startValue.keyword:''} end={endValue?endValue.keyword:''} />:null
				}
			</OverlayScrollbarsComponent>
			</div>
		</div>
	  
		{rpMode===1 &&
			<Footer pageCount={pages.pageCount} setPageIndex={setPageIndex}/>
		}
		<RPNearSearch/>
	</div>
	{ rpMode===2 &&	<WayPointSelect data={rpData} /> }
		
	</React.Fragment>
    );
  };
  
  export default RP;